import React, { useState } from "react";
import { Input, Label, Button, Modal, CardBody } from "reactstrap";
import { getInputs } from "../EngineerReport.model";
import { Field, FieldArray, FieldProps, useFormikContext } from "formik";
import env from "environment_system/env_system";
import ErrorTooltip from "Components/ErrorTooltip";
import ToolTip from "Components/ToolTip";
import { AlertColourTypeConstant, AlertTypeConstant, VesselMachineryConstant } from "shared/constants";
import { getAlertMessage } from "Alerts/AlertMessages";
import { useDocumentTitle } from "Components/useDocument.hooks";
import Message from "Components/Message";
import { useSelector } from "react-redux";
import { RootState } from "index";
import { checkForNaN } from "GenericForms/Helper";
import { useEditReport } from "VesselReportingInfo/EditCompletedReports/EditReportProvider";

interface EnergyParameterType {
    vesselMachineries: any[];
    modal_backdrop: boolean;
    energy_modal_backdrop: boolean;
    set_energy_modal_backdrop: any;
    setAlertBool: any;
    setAlertMessage: any;
    setAlertFieldValue: any;
    setAlertFieldLabel: any;
    setAlertColourType: any;
    setAlertType: any;
    setFieldId: any;
    alertBool: boolean;
}

const EnergyParameterCompenent = ({
    vesselMachineries,
    modal_backdrop,
    energy_modal_backdrop,
    set_energy_modal_backdrop,
    setAlertBool,
    setAlertMessage,
    setAlertFieldValue,
    setAlertFieldLabel,
    setAlertColourType,
    setAlertType,
    setFieldId,
    alertBool
}: EnergyParameterType) => {
    const { LimitsAndAlerts } = useSelector((state: RootState) => state.Reporting);
    const { discardwarning } = useEditReport();
    /** State variables */
    useDocumentTitle("Energy Parameters Report - ecoSAIL");
    const { CurrentReport } = useSelector((state: RootState) => state.Reporting);
    const reportBeaufortScale = checkForNaN(CurrentReport?.data?.deck_officer?.weather_data?.beaufort_scale);
    let { Energy_inputs } = getInputs("energy");
    const [modalIndex, setModalIndex] = useState(0);
    const { values, errors, handleChange, touched, handleBlur }:
        { values: any, errors: any, handleChange: any, touched: any, handleBlur: any, setErrors: any, setFieldValue: any, setFieldTouched: any } = useFormikContext();
    /** State variables end */

    function tog_backdrop() {
        set_energy_modal_backdrop(!energy_modal_backdrop);
        removeBodyCss();
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }
    /** Handle changes of energy developed, avg power & running hours */
    const handleEnergyParamterTextBoxChanges = (
        e: any,
        form: any,
        values: any,
        name: any,
        indx: number
    ) => {
        if (name === `energyParameter.${indx}.energy_developed` && values?.energyParameter[indx]) {
            form.setFieldValue(
                `energyParameter.${indx}.avg_power`,
                checkForNaN(checkForNaN(e.target.value) / checkForNaN(values?.energyParameter[indx].running_hours))
            );
        } else if (name === `energyParameter.${indx}.avg_power` && values?.energyParameter[indx]) {
            form.setFieldValue(
                `energyParameter.${indx}.energy_developed`,
                checkForNaN(checkForNaN(e.target.value) * checkForNaN(values?.energyParameter[indx].running_hours))
            );
        } else if (name === `energyParameter.${indx}.running_hours` && values?.energyParameter[indx].is_energy_meter_functional) {
            form.setFieldValue(
                `energyParameter.${indx}.avg_power`,
                checkForNaN(checkForNaN(values?.energyParameter[indx].energy_developed) / checkForNaN(e.target.value))
            );
        } else if (name === `energyParameter.${indx}.running_hours` && !values?.energyParameter[indx].is_energy_meter_functional) {
            form.setFieldValue(
                `energyParameter.${indx}.energy_developed`,
                checkForNaN(checkForNaN(values?.energyParameter[indx].avg_power) * checkForNaN(e.target.value))
            );
        }
    };
    const powerPerHour = reportBeaufortScale >= 5 ?
        checkForNaN(LimitsAndAlerts?.SpeedAndConsumption_power?.all_weather / 24) :
        checkForNaN(LimitsAndAlerts?.SpeedAndConsumption_power?.fair_weather / 24);
    return (
        <CardBody className="p-2">
            <div className="table-responsive p-0">
                <table className="table mb-2">
                    <thead className="table-light">
                        <tr>
                            <th className="p-2 align-middle sr-no-width">#</th>
                            {Energy_inputs.filter(
                                (table: any) => table.table_columns === true
                            )
                                .sort(
                                    (a: any, b: any) =>
                                        a.table_columns_sequence -
                                        b.table_columns_sequence
                                )
                                .map(({ name, ...props }) => {
                                    return (
                                        <th
                                            key={props.id}
                                            className={`p-2 align-middle ${name === "machinery_name" ? "text-left" : "text-center"} ${props?.className}`}
                                        >
                                            {props.label}
                                        </th>
                                    );
                                })}
                            <th
                                className="p-2 align-middle text-center"
                                style={{ width: "17%" }}
                            >
                                Sensor status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <FieldArray name="energyParameter">
                            {() => (
                                <>
                                    {vesselMachineries &&
                                        vesselMachineries.filter((item: any) => item.energy_parameter === true).length > 0 ? (
                                        vesselMachineries
                                            .filter((item: any) => item.energy_parameter === true)
                                            .map((vesselMachinery: any, indx: number) => (
                                                <tr key={vesselMachinery.id}>
                                                    <td className="p-2 align-middle text-center">{indx + 1}</td>

                                                    <td className="p-2 align-middle">
                                                        {vesselMachinery.vessel_machinery_name}
                                                    </td>
                                                    {/* ENERGY DEVELOPED */}
                                                    <td className="p-2 align-middle text-center">
                                                        <div className="d-inline-block">
                                                            <div className="input-group">
                                                                <Field name={`energyParameter.${indx}.energy_developed`}>
                                                                    {({ field, form }: FieldProps) => (
                                                                        <Input
                                                                            onFocus={(e) => e.target.select()}
                                                                            type="text"
                                                                            className="form-control text-right max-width-7"
                                                                            id={`energy_developed_${indx}`}
                                                                            name={field.name}
                                                                            value={values?.energyParameter[indx]?.energy_developed}
                                                                            onChange={(e: any) => handleChange(e)}
                                                                            onBlur={(e: any) => {
                                                                                handleBlur(e);
                                                                                handleChange(e);
                                                                                if (env.alerts === true) {
                                                                                    const isOperational = values?.energyParameter[indx]?.is_energy_meter_functional;
                                                                                    const RunningHours = values?.energyParameter[indx]?.running_hours;
                                                                                    if (
                                                                                        isOperational &&
                                                                                        RunningHours &&
                                                                                        vesselMachinery.machinery_precedence_id === VesselMachineryConstant.MAIN_ENGINE
                                                                                    ) {
                                                                                        const expectedPower = powerPerHour * RunningHours;
                                                                                        const lowerLimit = expectedPower * 0.8;
                                                                                        const upperLimit = expectedPower * 1.2;
                                                                                        const enteredValue = e.target.value;
                                                                                        if (enteredValue < lowerLimit || enteredValue > upperLimit) {
                                                                                            setAlertBool(true);
                                                                                            setAlertMessage(
                                                                                                getAlertMessage(
                                                                                                    "EnergyParameter",
                                                                                                    "expected_power",
                                                                                                    "Energy developed",
                                                                                                    enteredValue,
                                                                                                    `${lowerLimit.toFixed(2)}–${upperLimit.toFixed(2)}`
                                                                                                )
                                                                                            );
                                                                                            setAlertColourType(AlertColourTypeConstant.WARNING);
                                                                                            setAlertType(AlertTypeConstant.WITH_REASON);
                                                                                            setFieldId(`energy_developed_${indx}`);
                                                                                            setAlertFieldLabel("Energy developed");
                                                                                            setAlertFieldValue(field.value);
                                                                                        }
                                                                                    }
                                                                                }
                                                                                handleEnergyParamterTextBoxChanges(e, form, values, field.name, indx);
                                                                            }}
                                                                            disabled={!values?.energyParameter[indx]?.is_energy_meter_functional}
                                                                        />
                                                                    )}
                                                                </Field>
                                                                <div className="input-group-text">kWh</div>
                                                            </div>
                                                        </div>
                                                        {errors?.energyParameter &&
                                                            touched?.energyParameter &&
                                                            touched?.energyParameter[indx]?.energy_developed &&
                                                            errors?.energyParameter[indx]?.energy_developed &&
                                                            env?.form_validation === true &&
                                                            !alertBool &&
                                                            !energy_modal_backdrop &&
                                                            !modal_backdrop &&
                                                            !discardwarning && (
                                                                <ErrorTooltip
                                                                    target={`energy_developed_${indx}`}
                                                                    message={errors.energyParameter[indx].energy_developed}
                                                                    open={true}
                                                                />
                                                            )}
                                                    </td>
                                                    {/* RUNNING HOURS */}
                                                    <td className="p-2 align-middle text-center">
                                                        <div className="d-inline-block">
                                                            <div className="input-group">
                                                                <Field name={`energyParameter.${indx}.running_hours`}>
                                                                    {({ field, form }: FieldProps) => (
                                                                        <Input
                                                                            onFocus={(e) => e.target.select()}
                                                                            type="text"
                                                                            className="form-control text-right max-width-7"
                                                                            id={`running_hours_${indx}`}
                                                                            name={field.name}
                                                                            value={values?.energyParameter[indx]?.running_hours}
                                                                            onChange={(e: any) => handleChange(e)}
                                                                            onBlur={(e: any) => {
                                                                                handleBlur(e);
                                                                                handleChange(e);
                                                                                handleEnergyParamterTextBoxChanges(e, form, values, field.name, indx);
                                                                            }}
                                                                        />
                                                                    )}
                                                                </Field>
                                                                <div className="input-group-text">hrs</div>
                                                            </div>
                                                        </div>
                                                        {errors?.energyParameter &&
                                                            touched?.energyParameter &&
                                                            touched?.energyParameter[indx]?.running_hours &&
                                                            errors?.energyParameter[indx]?.running_hours &&
                                                            env?.form_validation === true &&
                                                            !alertBool &&
                                                            !modal_backdrop &&
                                                            !energy_modal_backdrop && !discardwarning && (
                                                                <ErrorTooltip
                                                                    target={`running_hours_${indx}`}
                                                                    message={errors.energyParameter[indx].running_hours}
                                                                    open={true}
                                                                />
                                                            )}
                                                    </td>
                                                    {/* AVG POWER */}
                                                    <td className="p-2 align-middle text-center">
                                                        <div className="d-inline-block">
                                                            <div className="input-group">
                                                                <Field name={`energyParameter.${indx}.avg_power`}>
                                                                    {({ field, form }: FieldProps) => (
                                                                        <Input
                                                                            onFocus={(e) => e.target.select()}
                                                                            type="text"
                                                                            className="form-control text-right max-width-7"
                                                                            id={`avg_power-${indx}`}
                                                                            name={field.name}
                                                                            value={values?.energyParameter[indx]?.avg_power}
                                                                            disabled={values?.energyParameter[indx]?.is_energy_meter_functional}
                                                                            onChange={(e: any) => handleChange(e)}
                                                                            onBlur={(e: any) => {
                                                                                handleBlur(e);
                                                                                handleChange(e);
                                                                                handleEnergyParamterTextBoxChanges(e, form, values, field.name, indx);
                                                                                if (env.alerts === true) {
                                                                                    const RunningHours = values?.energyParameter[indx]?.running_hours;
                                                                                    if (
                                                                                        RunningHours &&
                                                                                        vesselMachinery.machinery_precedence_id ===
                                                                                        VesselMachineryConstant.MAIN_ENGINE
                                                                                    ) {
                                                                                        const expectedPower = powerPerHour * RunningHours;
                                                                                        const lowerLimit = expectedPower * 0.8;
                                                                                        const upperLimit = expectedPower * 1.2;
                                                                                        const enteredValue = e.target.value;
                                                                                        if (enteredValue < lowerLimit || enteredValue > upperLimit) {
                                                                                            setAlertBool(true);
                                                                                            setAlertMessage(
                                                                                                getAlertMessage("EnergyParameter", "expected_power", "Average Power", enteredValue, `${lowerLimit.toFixed(2)}–${upperLimit.toFixed(2)}`)
                                                                                            );
                                                                                            setAlertColourType(AlertColourTypeConstant.WARNING);
                                                                                            setAlertType(AlertTypeConstant.WITH_REASON);
                                                                                            setFieldId(`avg_power-${indx}`);
                                                                                            setAlertFieldLabel("Average Power");
                                                                                            setAlertFieldValue(field.value);
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                    )}
                                                                </Field>
                                                                <div className="input-group-text">kW</div>
                                                            </div>
                                                        </div>
                                                        {errors?.energyParameter &&
                                                            errors?.energyParameter[indx]?.avg_power &&
                                                            touched?.energyParameter &&
                                                            touched?.energyParameter[indx]?.avg_power &&
                                                            env?.form_validation === true &&
                                                            !alertBool &&
                                                            !modal_backdrop &&
                                                            !energy_modal_backdrop && !discardwarning && (
                                                                <ErrorTooltip
                                                                    target={`avg_power-${indx}`}
                                                                    message={errors.energyParameter[indx].avg_power}
                                                                    open={true}
                                                                />
                                                            )}
                                                    </td>
                                                    {/* FUNCTIONAL STATUS BUTTON */}
                                                    <td className="p-2 align-middle text-center">
                                                        <Button
                                                            id={`sensor_${indx}`}
                                                            color={!values?.energyParameter[indx]?.is_energy_meter_functional && "danger"}
                                                            className={`btn ${!values?.energyParameter[indx]?.is_energy_meter_functional
                                                                ? "btn-danger"
                                                                : "functional-status-color"
                                                                } btn_size_8_cstm`}
                                                            onClick={() => {
                                                                tog_backdrop();
                                                                setModalIndex(indx);
                                                            }}
                                                            onMouseOver={() => setModalIndex(indx)}
                                                        >
                                                            {values?.energyParameter[indx]?.is_energy_meter_functional
                                                                ? "Functional"
                                                                : "Non-functional"}
                                                        </Button>
                                                        <ToolTip
                                                            target={`sensor_${indx}`}
                                                            message="Click here to change the status"
                                                        />
                                                    </td>
                                                </tr>
                                            ))
                                    ) : (
                                        <tr>
                                            <td colSpan={6} className="text-center py-3 text-muted">
                                                <Message message="No machineries configured" type="danger" width="400px" />
                                            </td>
                                        </tr>
                                    )}
                                </>
                            )}
                        </FieldArray>
                        <Modal
                            style={{ overflowY: "auto" }}
                            isOpen={energy_modal_backdrop}
                            toggle={() => {
                                tog_backdrop();
                            }}
                            backdrop={"static"}
                            id="staticBackdrop"
                        >
                            <div className="modal-header">
                                <h5
                                    className="modal-title"
                                    id="staticBackdropLabel"
                                >
                                    Action
                                </h5>
                            </div>
                            <div className="modal-body">
                                <strong>Please Note -</strong>
                                <p>Select Yes if Energy meter is functional</p>
                                <div className="d-flex flex-wrap gap-2 align-items-center">
                                    <Label htmlFor="is_energy_meter_functional">
                                        Energy meter functional?
                                    </Label>
                                    <Field name={`energyParameter.${modalIndex}.is_energy_meter_functional`}>
                                        {({ field }: FieldProps) => (
                                            <div className="square-switch sqswitch d-flex align-items-center">
                                                <Input
                                                    onFocus={(e) => e.target.select()}
                                                    type="checkbox"
                                                    switch="none"
                                                    name={field.name}
                                                    id="is_energy_meter_functional"
                                                    checked={values?.energyParameter[modalIndex]?.is_energy_meter_functional}
                                                    onChange={(e: any) => {
                                                        handleChange(e);
                                                    }}
                                                />
                                                <Label
                                                    htmlFor="is_energy_meter_functional"
                                                    data-on-label="Yes"
                                                    data-off-label="No"
                                                />
                                                {errors?.energyParameter &&
                                                    errors?.energyParameter[modalIndex]?.is_energy_meter_functional &&
                                                    env?.form_validation ===
                                                    true && !alertBool && !modal_backdrop && !energy_modal_backdrop && !discardwarning && (
                                                        <ErrorTooltip
                                                            target={`is_energy_meter_functional`}
                                                            message={errors?.energyParameter[modalIndex]?.is_energy_meter_functional}
                                                            open={
                                                                (errors?.energyParameter &&
                                                                    errors?.energyParameter[modalIndex]?.is_energy_meter_functional) && !modal_backdrop && !energy_modal_backdrop
                                                                    ? true : false
                                                            }
                                                        />
                                                    )}
                                            </div>
                                        )}
                                    </Field>
                                </div>
                                <Button
                                    type="button"
                                    color="primary"
                                    className="btn_size_cstm justify_right"
                                    onClick={() => {
                                        set_energy_modal_backdrop(false);
                                    }}
                                >
                                    Ok
                                </Button>
                            </div>
                        </Modal>
                    </tbody>
                </table>
            </div>
        </CardBody>
    );
};
export default EnergyParameterCompenent;
